import {PropsWithChildren} from 'react';
import * as styles from './inputPrefix.module.css';

interface IInputPrefix {
    prefix?: string,
    title?: string,
    icon?: JSX.Element,
    titleIcon?: JSX.Element,
}

const InputPrefix = ({
    prefix, title, icon, titleIcon, children,
}: PropsWithChildren<IInputPrefix>) => (
    <div className={styles.root}>
        <div className={styles.title}>
            <span>{title}</span>
            <div className={styles.titleIcon}>{titleIcon && titleIcon}</div>
        </div>
        <div className={styles.inputWrapper}>
            {icon && icon}
            {prefix && (
                <span className={styles.prefix}>
                    {prefix}
                </span>
            )}
            {children}
        </div>
    </div>
);

export default InputPrefix;
